export const CWC23_TEAM_ID_LIST = [
  "AFG",
  "AUS",
  "BGD",
  "ENG",
  "IND",
  "NLD",
  "NZL",
  "PAK",
  "ZAF",
  "LKA",
];
